/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocationVo
 */
export interface LocationVo {
    /**
     * 货位号
     * @type {string}
     * @memberof LocationVo
     */
    locationNo?: string;
    /**
     * 箱号/唛头号
     * @type {string}
     * @memberof LocationVo
     */
    boxNo?: string;
    /**
     * 是否单独保管：0 否 1 是
     * @type {number}
     * @memberof LocationVo
     */
    separateStore?: number;
    /**
     * 该货位可用数量
     * @type {number}
     * @memberof LocationVo
     */
    availableQty?: number;
}

/**
 * Check if a given object implements the LocationVo interface.
 */
export function instanceOfLocationVo(value: object): value is LocationVo {
    return true;
}

export function LocationVoFromJSON(json: any): LocationVo {
    return LocationVoFromJSONTyped(json, false);
}

export function LocationVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationVo {
    if (json == null) {
        return json;
    }
    return {
        
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'boxNo': json['boxNo'] == null ? undefined : json['boxNo'],
        'separateStore': json['separateStore'] == null ? undefined : json['separateStore'],
        'availableQty': json['availableQty'] == null ? undefined : json['availableQty'],
    };
}

export function LocationVoToJSON(json: any): LocationVo {
    return LocationVoToJSONTyped(json, false);
}

export function LocationVoToJSONTyped(value?: LocationVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationNo': value['locationNo'],
        'boxNo': value['boxNo'],
        'separateStore': value['separateStore'],
        'availableQty': value['availableQty'],
    };
}

